import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { DATEPICKER_KEY } from "../../../components/survey-widgets/datepicker-widget";

export const projectPlanConfig: PageConfig[] = [
  {
    name: "projectSize",
    title: "Initiative Size",
    questions: [
      {
        type: "radiogroup",
        name: "initiativeSize",
        title: "Size of Initiative",
        choices: [
          { value: "small", text: "<$2,500" },
          { value: "large", text: "$2,500 - $8,000" },
        ],
        isRequired: true,
      },
    ],
  },
  {
    name: "planSmall",
    title: "Project Plan",
    questions: [
      {
        type: "comment",
        name: "planSmall",
        title: `
          Please tell us the details of how you plan to deliver your initiative.
          Please include information such as the start and end dates, who will
          be delivering this initiative, where this will be delivered, and how
          it will be delivered etc.
        `,
        placeHolder: "He aha te mahere?",
        visibleIf: "{initiativeSize} = 'small'",
        isRequired: true,
      },
    ],
  },
  {
    name: "projectPlanType",
    title: "Project Plan",
    questions: [
      {
        type: "radiogroup",
        name: "projectPlanType",
        title: "You need to provide a project plan",
        choices: [
          { value: "file", text: "I will upload a project plan file" },
          {
            value: "inline",
            text: "I will enter details into this form directly",
          },
        ],
        visibleIf: "{initiativeSize} = 'large'",
        isRequired: true,
      },
    ],
  },
  {
    name: "planLarge",
    title: "Project Plan Upload",
    visibleIf: "{projectPlanType} = 'file'",
    questions: [
      {
        type: "file",
        name: "planUpload",
        title: "Please upload a project plan",
        storeDataAsText: false,
        allowMultiple: false,
        maxSize: 10485760,
        waitForUpload: true,
        startWithNewLine: true,
        isRequired: true,
      },
    ],
  },
  {
    name: "planLarge",
    title: "Project Plan Entry",
    visibleIf: "{projectPlanType} = 'inline'",
    questions: [
      {
        type: DATEPICKER_KEY,
        inputType: "date",
        name: "startDate",
        title: "Start Date",
        isRequired: true,
      },
      {
        type: DATEPICKER_KEY,
        inputType: "date",
        name: "endDate",
        title: "End Date",
        startWithNewLine: false,
      },
      {
        type: DATEPICKER_KEY,
        inputType: "date",
        name: "deliveryDate",
        title: "Delivery Date",
        startWithNewLine: false,
      },
      {
        type: "text",
        name: "delivery",
        title: "Who is responsible for delivering this initiative?",
        placeHolder: "Mā wai e mahi?",
        isRequired: true,
      },
      {
        type: "text",
        name: "deliveryPlatform",
        title: "Location or platform for delivery",
        placeHolder: "Mā pēhea e mahi?",
        isRequired: true,
        startWithNewLine: false,
      },
    ],
  },
  {
    name: "planLargeSteps",
    title: "Project Plan Steps",
    visibleIf: "{projectPlanType} = 'inline'",
    questions: [
      {
        type: "comment",
        name: "planStepsPreparation",
        title: "Steps that will need to be taken in preparation",
        placeHolder: "Me aha kia rite?",
      },
      {
        type: "comment",
        name: "planStepsPlanning",
        title: "Steps that will need to be taken during planning",
        placeHolder: "Me aha kia whakamahere?",
      },
      {
        type: "comment",
        name: "planStepsDelivery",
        title: "Steps that will need to be taken during delivery",
        placeHolder: "Me aha kia mahi?",
      },
    ],
  },
  {
    name: "planLargeOther",
    title: "Project Plan Other",
    visibleIf: "{projectPlanType} = 'inline'",
    questions: [
      {
        type: "comment",
        name: "planStepsOther",
        title: "Provide any other relevant details",
        placeHolder: "He aha kē?",
      },
    ],
  },
];
